import * as m from "@paraglide/messages"
import { PlaydataButtonLink, PlaydataSection } from "@playdata/PlaydataPrimitives"
import type { SupportedLocale } from "@site-types/content"
import { createFileRoute } from "@tanstack/react-router"
import { playdataRouteHead } from "@utils/playdata-route-head"

export const Route = createFileRoute("/$locale/playdata/report")({
  head: ({ params }) => {
    const locale = params.locale as SupportedLocale
    return playdataRouteHead({
      description: m.playdata_report_meta_description({}, { locale }),
      locale,
      path: "/playdata/report",
      title: m.playdata_report_meta_title({}, { locale }),
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: raw } = Route.useParams()
  const locale = raw as SupportedLocale
  return (
    <>
      <PlaydataSection tone="blue">
        <div className="grid items-center gap-[4rem] md:grid-cols-2">
          <div className="flex flex-col items-start gap-[2rem]">
            <h1 className="text-[3rem] leading-[1.35] md:text-[3.8rem]">
              <strong>{m.playdata_report_heading({}, { locale })}</strong>
            </h1>
            <p className="text-[1.6rem] leading-[1.7]">{m.playdata_report_lead({}, { locale })}</p>
          </div>
          <img
            alt=""
            className="h-auto w-full"
            height={900}
            loading="lazy"
            src="/images/playdata/report-2025-cover.jpg"
            width={1600}
          />
        </div>
      </PlaydataSection>
      <PlaydataSection>
        <div className="flex flex-col items-center gap-[2.4rem] text-center">
          <h2 className="text-[2.4rem]">{m.playdata_report_formHeading({}, { locale })}</h2>
          <PlaydataButtonLink
            params={{ locale }}
            to="/$locale/contact"
          >
            {m.playdata_common_contactCta({}, { locale })}
          </PlaydataButtonLink>
        </div>
      </PlaydataSection>
    </>
  )
}
